import { createSelector } from 'reselect';
import topLevelCategoryList from 'core/modules/ProductSearchResults/utils/topLevelCategoryList';

export const selectProductSearchResults = state => state.productSearchResults;

export const selectProductSearchResultsConfig = createSelector(
  selectProductSearchResults,
  productSearchResults => productSearchResults.config,
);

export const selectProductSearchResultsIsLoading = createSelector(
  selectProductSearchResults,
  productSearchResults => productSearchResults.isLoading,
);

export const selectProductSearchResultsIsLoaded = createSelector(
  selectProductSearchResults,
  productSearchResults => productSearchResults.isLoaded,
);

export const selectProductSearchResultsIsFiltering = createSelector(
  selectProductSearchResults,
  productSearchResults => productSearchResults.isFiltering,
);

export const selectProductSearchResultsIsFiltered = createSelector(
  selectProductSearchResults,
  productSearchResults => productSearchResults.isFiltered,
);

export const selectProductSearchResultMetadata = createSelector(
  selectProductSearchResults,
  productSearchResults => productSearchResults?.payload?.metadata || {},
);

export const selectProductSearchResultResponse = createSelector(
  selectProductSearchResults,
  productSearchResults => productSearchResults?.payload?.response || [],
);

export const selectProductSearchResultInitialFacets = createSelector(
  selectProductSearchResults,
  ({ initialFacets }) => (
    initialFacets.reduce((result, initialFacet) => {
      // Filter out top level categories from filter dropdown
      if (initialFacet.name === 'categories') {
        initialFacet.values = initialFacet.values.filter(value => !topLevelCategoryList.includes(value.id));
      }

      return {
        ...result,
        [initialFacet.name]: {
          name: initialFacet.name,
          label: initialFacet.label,
          values: initialFacet.values,
        },
      };
    }, {})
  ),
);
